import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Http, Headers} from '@angular/http';
import {GlobalService} from './global.config';
import {DateInterval} from '../objects/data-management'
import {createAuthorizationHeader} from "../utils/headers";
import {Events } from 'ionic-angular';

@Injectable()
export class HeaderService {
dns:string;
    constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
        this.dns = globalService.getDns();
         console.log(this.dns);
    }

    alertSeen(alertDate: any, deviceId): Observable<any> {
        let headers = new Headers({'Accept': 'application/json'});
        createAuthorizationHeader(headers);
        return this._http.post(this.dns + 'alert/seen/', deviceId + '/' + alertDate, {headers: headers}).map(res => res.json());
    }

    getUnseenAlerts(dateInterval: DateInterval): Observable<number> {
        let headers = new Headers({'Accept': 'application/json'});
        createAuthorizationHeader(headers);
        return this._http.post(this.dns + 'alerts/day/', dateInterval, {headers: headers}).map(res => res.json());
    }

    getListAlerts(dateInterval: DateInterval): Observable<any[]> {
        let headers = new Headers({'Accept': 'application/json'});
        createAuthorizationHeader(headers);
        return this._http.post(this.dns + 'alerts/notificationsday/', dateInterval, {headers: headers}).map(res => res.json());
    }

}



// WEBPACK FOOTER //
// ./src/providers/header.service.ts